import Vue from 'vue'
import { Validator } from "vee-validate";

Validator.extend("alpha_name", {
    validate: value => {
        var strongRegex = new RegExp(/^[a-zA-Z-äöüÄÖÜ\u00C0-\u00FF .]+$/);
        // new RegExp(/^[A-Za-z\d\s]+$/);
        return strongRegex.test(value);
    }
});

import moment from 'moment'
import axios from 'axios'
const myMixin = Vue.mixin({
    data() {
        return {
            button_loading: false,
            current_locale: 'en',
            openComponent: false,
            recordList: [{
                text: 10,
                value: 10
            },
            {
                text: 25,
                value: 25
            },
            {
                text: 50,
                value: 50
            },
            {
                text: 100,
                value: 100
            },
            {
                text: 250,
                value: 250
            }
            ],
        }
    },

    created() {
        if (this.$store) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('authToken')
            //this.axios.defaults.headers.common['locale'] = this.current_locale

        }
    },
    methods: {
        slugify(string) {
            return string
                .toString()
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-")
                .replace(/[^\w\-]+/g, "")
                .replace(/\-\-+/g, "-")
                .replace(/^-+/, "")
                .replace(/-+$/, "");
        },
        focusTextField() {
            setTimeout(() => {
                document.getElementById("textName").focus();
            }, 100);
        },
        setValidationMessage() {
            let dict = {
                custom: {
                    email: {
                        required: this.$t('validations.enter_email'),
                        email: this.$t('validations.enter_valid_email')
                    },
                    otp: {
                        required: this.$t('validations.enter_otp'),
                        length: this.$t('validations.otp_size')
                    },
                    password: {
                        required: this.$t('validations.enter_password'),
                        min: this.$t('validations.password_validation'),
                        regex: this.$t('validations.password_regex'),
                    },
                    password_confirmation: {
                        required: this.$t('validations.enter_confirm_password'),
                        confirmed: this.$t('validations.confirm_password_validation')
                    },
                    old_password: {
                        required: this.$t('validations.enter_old_password'),
                    },
                    new_password: {
                        required: this.$t('validations.enter_admin_new_password'),
                    },
                    // name: {
                    //   required: this.$t('validations.enter_name'),
                    // },
                    designation: {
                        required: this.$t('validations.enter_designation'),
                    },
                    name: {
                        required: this.$t('validations.name'),
                        alpha_spaces: this.$t('validations.name_alpha'),
                        // max: this.$t('validations.name_max'),
                    },
                    t_name: {
                        required: this.$t('validations.t_name'),
                        alpha_spaces: this.$t('validations.name_alpha'),
                    },

                    mobile: {
                        required: this.$t('validations.mobile'),
                    },

                    price: {
                        required: this.$t('validations.price'),
                        alpha_num: this.$t('validations.price_digit'),
                    },

                    link: {
                        required: this.$t('validations.url'),
                    },

                    participants: {
                        required: this.$t('validations.participants'),
                        alpha_num: this.$t('validations.numeric'),
                    },
                    interest_icon: {
                        required: this.$t('validations.interest_icon_select'),
                    },
                    language: {
                        required: this.$t('validations.language_name'),
                        alpha_spaces: this.$t('validations.language_name_alpha'),
                    },

                    technology: {
                        required: this.$t('validations.technology_name'),
                        alpha_spaces: this.$t('validations.language_name_alpha'),
                    },

                    interest: {
                        required: this.$t('validations.interest_name')
                        // alpha_spaces: this.$t('validations.interest_name_alpha')
                    },
                    testimonial: {
                        required: this.$t('validations.testimonial_name'),
                        alpha_spaces: this.$t('validations.testimonial_name_alpha')
                    },
                    subcategory_name: {
                        alpha_spaces: this.$t('validations.subcategory_name'),
                    },
                    characteristic: {
                        required: this.$t('validations.characteristic_name'),
                        alpha_spaces: this.$t('validations.characteristic_name_alpha'),
                    },

                    InterestfileUpload: {
                        required: this.$t('validations.InterestUploadValidation'),
                    },

                    whome: {
                        required: this.$t('validations.whome'),
                    },

                    startDate: {
                        required: this.$t('validations.startDate'),
                    },
                    endDate: {
                        required: this.$t('validations.endDate'),
                    },

                    startTime: {
                        required: this.$t('validations.startTime'),
                    },

                    dropIcon: {
                        required: this.$t('validations.select_icon'),
                    },

                    endTime: {
                        required: this.$t('validations.endTime'),
                    },

                    position: {
                        required: this.$t('validations.position'),
                        alpha_spaces: this.$t('validations.postion_name_alpha'),
                    },

                    worklife: {
                        required: this.$t('validations.worklife'),
                        alpha_spaces: this.$t('validations.fulltime_alpha'),
                    },
                    age: {
                        required: this.$t('validations.age'),
                    },
                    category: {
                        required: this.$t('validations.category_name'),
                        alpha_spaces: this.$t('validations.category_name_alpha')
                    },
                    subcategory: {
                        required: this.$t('validations.subcategory_name'),
                        alpha_spaces: this.$t('validations.subcategory_name_alpha'),
                    },
                    subcategory_type: {
                        required: this.$t('validations.subcategory_type'),
                    },
                    category_list: {
                        required: this.$t('validations.category_list'),
                    },
                    title: {
                        required: this.$t('validations.title'),
                        alpha_spaces: this.$t('validations.name_alpha'),
                        // max:30:this.$t('validations.title_max'),
                    },
                    brief: {
                        required: this.$t('validations.brief'),
                    },
                    address: {
                        required: this.$t('validations.address'),
                    },
                    ImageValidation: {
                        required: this.$t('validations.fileUpload_image'),
                    },
                    description: {
                        required: this.$t('validations.description'),
                    },
                    min_age: {
                        required: this.$t('validations.min_age'),
                    },

                    max_age: {
                        required: this.$t('validations.max_age'),
                    },
                    reason: {
                        required: this.$t('validations.my_reason'),
                    },


                    slug: {
                        required: this.$t('validations.slug'),
                    },
                    users: {
                        required: this.$t('validations.users'),
                        alpha_num: this.$t('validations.numeric'),
                    },

                    characteristics: {
                        required: this.$t('validations.characteristics'),
                    },
                    description: {
                        required: this.$t('validations.description'),
                    },
                    char_name: {
                        required: this.$t('validations.char_name'),
                    },

                    facebook: {
                        required: this.$t('validations.facebook'),
                    },

                    instagram: {
                        required: this.$t('validations.instagram'),
                    },

                    reject: {
                        required: this.$t('validations.Enter_reason'),
                    },
                    subcategory_select: {
                        required: this.$t('validations.subcategory_select'),
                    },
                    client_id: {
                        required: this.$t('validations.enter_client_id'),
                        max: this.$t('validations.max_client_id')
                    },
                    client_secret: {
                        required: this.$t('validations.enter_client_secret'),
                        max: this.$t('validations.max_client_secret')
                    },
                    charge: {
                        required: this.$t('validations.charge'),
                        between: this.$t('validations.between_charge'),
                    },
                    vat: {
                        required: this.$t('validations.vat'),
                        between: this.$t('validations.between'),
                    },

                    refund_class: {
                        required: this.$t('validations.max_class'),
                        between: this.$t('validations.cancel_max'),
                    },

                    days: {
                        required: this.$t('validations.days'),
                        between: this.$t('validations.between_day'),
                    },

                    week: {
                        required: this.$t('validations.week'),
                        between: this.$t('validations.between_week'),
                    },

                    month: {
                        required: this.$t('validations.month'),
                        between: this.$t('validations.between_month'),
                    },
                    minage: {
                        max_value: this.$t("validations.minage_max_value")
                    },

                    device: {
                        max_value: this.$t("validations.device_value")
                    },

                    events: {
                        required: this.$t("validations.events_value")
                    },

                    places: {
                        required: this.$t("validations.places_value")
                    },
                    classes: {
                        required: this.$t("validations.classes_value")
                    },
                    services: {
                        required: this.$t("validations.services_value")
                    },
                    status: {
                        required: this.$t("validations.status_value")
                    },
                    day: {
                        required: this.$t("validations.day_value")
                    },
                    title_suffix: {
                        required: this.$t("validations.title_suffix"),
                        alpha_name: this.$t('validations.alpha_name'),
                        max: this.$t('validations.max_title_suffix')
                    },
                    bring_items: {
                        max: this.$t('validations.max_bring_items')
                    },
                    technology: {
                        required: this.$t("validations.technology")
                    },
                    Tname: {
                        required: this.$t("validations.Teacher_name"),
                        alpha_spaces: this.$t('validations.name_alpha'),
                    },
                    question:{
                        required: this.$t("validations.question"),
                    },
                    answer: {
                        required: this.$t("validations.answer"),
                    },
                    privacy_policy:{
                        required: this.$t("validations.privacy_policy"),
                        url: this.$t('validations.url'),
                    },
                    t_and_c:{
                        required: this.$t("validations.t_and_c"),
                        url: this.$t('validations.url'),
                    }

                }
            };
            Validator.localize("en", dict);
        },
        logout() {
            localStorage.removeItem('authToken')
            localStorage.removeItem('user')
            localStorage.removeItem('auth')
            // location.href = this.$router.history.base;
            // console.log(process.env)
            location.href = process.env.BASE_URL
            /* this.$router.push({
              name: 'login'
            }) */
        },
        button_loader(val, container) {
            this.button_loading = val
            if (val) {
                this.$vs.loading({
                    background: 'primary',
                    color: '#fff',
                    container: container,
                    scale: 0.45
                })
            } else {
                this.$vs.loading.close(container + ' > .con-vs-loading')
            }
        },


        button_loader_success(val, container) {
            if (val) {
                this.$vs.loading({
                    background: this.backgroundLoading,
                    color: this.colorLoading,
                    container: "#page-loading",
                    scale: 0.45
                })
            } else {
                this.$vs.loading.close(container + ' > .con-vs-loading')
            }
        },

        showError(e, button_loader = null) {
            button_loader ? this.button_loader(false, button_loader) : this.$vs.loading.close();
            if (e.response && e.response.status === 401) {
                this.$vs.notify({
                    text: 'Your session is expired!!!',
                    color: "danger",
                    position: "top-right"
                });
                this.logout()
            }
            if (e.response && e.response.status === 403) {
                this.$vs.notify({
                    text: 'Permission denied',
                    color: "danger",
                    position: "top-right"
                });
                this.logout()
            }
            if (!e.response || !e.response.data || !e.response.data.message) {
                return
            }
            let error = e.response.data.message;
            this.$vs.notify({
                text: error,
                color: "danger",
                position: "top-right",
                scale: 10
            });

        },
    },

    filters: {
        descLimit: function (value) {
            if (!value) return '';
            return value.substring(0, 50) + '...';
        },
        limitTo: function (value) {
            if (!value) return '';
            return value.substring(0, 9) + '...';
        },
        str_limit(value, size) {
            if (!value) return '';
            value = value.toString();

            if (value.length <= size) {
                return value;
            }
            return value.substr(0, size) + '';
        },

        short_char: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(10).toUpperCase() + value.slice(0)
        },
        // ShortNotification
        ShortNotification: function (array) {
            return array.slice(1)
        },

        getAge(DOB) {
            var today = new Date();
            var birthDate = new Date(DOB);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age = age - 1;
            }

            return age;
        },

        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
        },

        formatTime: function (value) {
            if (value) {
                //return moment(String(value)).format('hh:mm')
                let valueArray = moment(String(value)).format('DD/MM/YYYY hh:mm:ss');
                let timeArray = valueArray.split(" ");
                return timeArray[1];
            }
        },

        formatDateTime: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY hh:mm:ss A')
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },

        fullday: function (value) {
            if (!value) return ''
            let day = '';
            switch (value) {
                case 'mon':
                    day = 'Monday';
                    break;

                case 'tue':
                    day = 'Tuesday';
                    break;

                case 'wed':
                    day = 'Wednesday';
                    break;

                case 'thu':
                    day = 'Thursday';
                    break;
                case 'fri':
                    day = 'Friday';
                    break;

                case 'sat':
                    day = 'Saturday';
                    break;

                case 'sun':
                    day = 'Sunday';
                    break;
                default:
                    break;

            }
            return day;
        },

        address_formats(str) {
            if (!str) return
            let address = ''
            str = JSON.parse(str);
            if (str.street_address1) {
                address += str.street_address1
            }
            if (str.street_address2) {
                address += ', ' + str.street_address2
            }
            if (str.city) {
                address += ', ' + str.city
            }
            if (str.state) {
                address += ', ' + str.state
            }
            if (str.zipcode) {
                address += ', ' + str.zipcode
            }

            if (str.country) {
                address += ', ' + str.country
            } else if (str.country) {
                address += ', ' + str.country
            }
            return address
        },
        address_format(str) {
            if (!str) return
            let address = ''
            str = JSON.parse(str);
            if (str.city) {
                str.city.toLowerCase().split(' ');
                address += str.city.charAt(0).toUpperCase() + str.city.slice(1);

            }
            if (str.zipcode) {
                address += ', ' + str.zipcode
            }
            return address
        },
        upper(value) {
            if (value != undefined) {
                return value.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
            }

        },
        firstUpper(value) {
            if(value != undefined){
                value.toLowerCase().split(' ');
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        interest(value) {
            if (value != undefined) {
                let interest = '';
                for (var i = 0; i < value.length; i++) {
                    if (i == value.length - 1) {
                        interest += value[i].code;
                    }
                    else {
                        interest += value[i].code + ", ";
                    }

                }
                return interest;
            }

        },
        experience(value) {
            if (value != undefined) {
                let interest = '';
                for (var i = 0; i < value.length; i++) {
                    if (i == value.length - 1) {
                        if (value[i] == "1") {
                            interest += value[i] + " Year";
                        }
                        else {
                            interest += value[i] + " Years";
                        }

                    }
                    else {
                        if (value[i] == "1") {
                            interest += value[i] + " Year ,";
                        }
                        else {
                            interest += value[i] + " Years ,";
                        }

                    }

                }
                return interest;
            }

        },
        experiences(value) {
            let experience = '';
            str = JSON.parse(value);
            return str;
        }

    }

});

